import { NgModule } from '@angular/core';
import { HomeNavComponent } from './home-nav.component';

@NgModule({
  declarations: [HomeNavComponent],
  exports: [HomeNavComponent]
})

export class HomeNavModule {}
